'use client';
import * as React from 'react';

const AccordionContext = /*#__PURE__*/ React.createContext(undefined);
AccordionContext.displayName = 'AccordionContext';
// we don't warn if you try to use this context outside an Accordion
// because Collapsible may be used outside of Accordions
// Collapsible will need to check if this is undefined before using it
function useAccordionContext() {
    return React.useContext(AccordionContext);
}

export { AccordionContext, useAccordionContext };
